/* eslint-disable import/no-cycle */
import { defineStore } from 'pinia';
import { INotification, IPagination } from '@/types/interfaces';
import AlertsService from '../services/AlertsService';
import { useSpacesStore } from '@/modules/spaces/store/spacesStore';
import { NOTIFICATION_STATUS, NOTIFICATION_TYPE } from '@/types/enums';

export type AlertState = {
  notifications: IPagination<INotification[]>
}

export const useAlertsStore = defineStore({
  id: 'alertsStore',

  state: () => ({
    notifications: {
      data: [],
      page: 0,
      lastPage: -1,
    },
  } as AlertState),

  actions: {
    async fetchNotifications(initial = false): Promise<INotification[]> {
      if (initial) {
        this.notifications.page = 0;
        this.notifications.lastPage = -1;
      }
      return AlertsService.fetchAlerts(this.notifications.page, '').then((response) => {
        if (response.success) {
          const alerts = response.results.data.items;
          if (this.notifications.page > 0 && !initial) {
            this.notifications.data.push(...alerts);
          } else {
            this.notifications.data = alerts || [];
          }
          this.notifications.page += 1;
          this.notifications.lastPage = Math.floor(response.results.data.paging.items / response.results.data.paging.itemsOnPage) + 1;
        }
        return this.notifications.data;
      });
    },

    manageContact(contactId: string, accept: boolean): void {
      const spacesStore = useSpacesStore();
      if (accept) {
        spacesStore.acceptContact(contactId);
      } else {
        spacesStore.rejectContact(contactId);
      }

      this.notifications.data = this.notifications.data.map((notification) => {
        if (notification.partnerId.internalId === contactId && notification.type === NOTIFICATION_TYPE.CONTACT_REQUEST_SENT) {
          // eslint-disable-next-line no-param-reassign
          notification.status = accept ? NOTIFICATION_STATUS.ACCEPTED : NOTIFICATION_STATUS.REJECTED;
        }
        return notification;
      });
    },

    manageGroup(groupId: string, partnerId: string, accept: boolean): void {
      const spacesStore = useSpacesStore();
      if (accept) {
        spacesStore.acceptRequestToGroup(groupId, partnerId);
      } else {
        spacesStore.rejectRequestToGroup(groupId, partnerId);
      }

      this.notifications.data = this.notifications.data.map((notification) => {
        if (notification.sharedInfo?.id === groupId && notification.type === NOTIFICATION_TYPE.GROUP_REQUEST_SENT) {
          // eslint-disable-next-line no-param-reassign
          notification.status = accept ? NOTIFICATION_STATUS.ACCEPTED : NOTIFICATION_STATUS.REJECTED;
        }
        return notification;
      });
    },

    manageRequestToGroup(groupId: string, partnerId: string, accept: boolean): void {
      const spacesStore = useSpacesStore();
      if (accept) {
        spacesStore.acceptUserToGroup(groupId, partnerId);
      } else {
        spacesStore.rejectUserToGroup(groupId, partnerId);
      }

      this.notifications.data = this.notifications.data.map((notification) => {
        if (notification.sharedInfo?.id === groupId && notification.type === NOTIFICATION_TYPE.IN_GROUP_REQUEST_SENT) {
          // eslint-disable-next-line no-param-reassign
          notification.status = accept ? NOTIFICATION_STATUS.ACCEPTED : NOTIFICATION_STATUS.REJECTED;
        }
        return notification;
      });
    },
  },

  getters: {
  },
});
